/* eslint-disable
    func-names,
    no-unused-vars,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
const _ = require('lodash');

const printStates = function (states, logger) {
  let a;
  return (a = _(states)
    .filter(state => !state.abstract)
    .forEach(state => {
      logger.log(state.name, 'success');
      return logger.log(`\t${state.url}`, 'warn');
    })
    .value());
};

module.exports = printStates;
